/**
 * Custom timestamps keys
 *
 * @note Keep this in sync with the key constants in the backend (see User.php)
 */

export const ADDONS_ANNOUNCED_AT = 'addons_announced_at';
